/*
 * smoothscroll polyfill - v0.3.5
 * https://iamdustan.github.io/smoothscroll
 * 2016 (c) Dustan Kasten, Jeremias Menichelli - MIT License
 *
 * https://developer.mozilla.org/en/docs/Web/CSS/scroll-behavior
 *
 * EDITED: left only window.scroll method
 */
(function (w, d) {
    if ('scrollBehavior' in d.documentElement.style) {
        return;
    }

    let SCROLL_TIME = 468;

    let original = {
        scroll: w.scroll,
    };

    let now = w.performance && w.performance.now
        ? w.performance.now.bind(w.performance) : Date.now;

    function scrollElement (x, y) {
        this.scrollLeft = x;
        this.scrollTop = y;
    }

    function ease (k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    function shouldBailOut (x) {
        if (typeof x !== 'object' ||
            x === null ||
            x.behavior === undefined ||
            x.behavior === 'auto' ||
            x.behavior === 'instant') {
            return true;
        }

        if (typeof x === 'object' &&
            x.behavior === 'smooth') {
            return false;
        }

        throw new TypeError('behavior not valid');
    }

    function step (context) {
        let time = now();
        let value;
        let currentX;
        let currentY;
        let elapsed = (time - context.startTime) / SCROLL_TIME;

        elapsed = elapsed > 1 ? 1 : elapsed;

        value = ease(elapsed);

        currentX = context.startX + (context.x - context.startX) * value;
        currentY = context.startY + (context.y - context.startY) * value;

        context.method.call(context.scrollable, currentX, currentY);

        if (currentX !== context.x || currentY !== context.y) {
            w.requestAnimationFrame(step.bind(w, context));
        }
    }

    function smoothScroll (el, x, y) {
        let scrollable;
        let startX;
        let startY;
        let method;
        let startTime = now();

        if (el === d.body) {
            scrollable = w;
            startX = w.scrollX || w.pageXOffset;
            startY = w.scrollY || w.pageYOffset;
            method = original.scroll;
        } else {
            scrollable = el;
            startX = el.scrollLeft;
            startY = el.scrollTop;
            method = scrollElement;
        }

        step({
            scrollable: scrollable,
            method: method,
            startTime: startTime,
            startX: startX,
            startY: startY,
            x: x,
            y: y,
        });
    }

    w.scroll = function () {
        if (shouldBailOut(arguments[0])) {
            original.scroll.call(
                w,
                arguments[0].left || arguments[0],
                arguments[0].top || arguments[1],
            );
            return;
        }

        smoothScroll.call(
            w,
            d.body,
            ~~arguments[0].left,
            ~~arguments[0].top,
        );
    };
})(window, document);

(function (ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
    ELEMENT.closest = ELEMENT.closest || function closest (selector) {
        if (!this) return null;
        if (this.matches(selector)) return this;
        if (!this.parentElement) { return null; } else return this.parentElement.closest(selector);
    };
}(Element.prototype));

if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

(function (arr) {
    arr.forEach(function (item) {
        if (Object.prototype.hasOwnProperty.call(item, 'prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend () {
                let argArr = Array.prototype.slice.call(arguments);
                let docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    let isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.insertBefore(docFrag, this.firstChild);
            },
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
